import { BaseOptionDefinition } from './base-option-definition'

export class OptionDefinition extends BaseOptionDefinition {}
